;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

export type ListOrganizationMembersQueryVariables = {
  iOrganizationId: string
  after?: string | null
  before?: string | null
  first?: number | null
  last?: number | null
}

export type ListOrganizationMembersMemberNode = {
  firstName?: string | null
  joinedAt?: string | null
  lastName?: string | null
  organizationId?: string | null
  displayRole?: string | null
  isPublic?: boolean | null
  photoUrl?: string | null
  role?: string | null
  userId?: string | null
  providerId?: number | null
  published?: boolean | null
  profilePendingPublication?: boolean | null
  providerProfilePublished?: boolean | null
  baaZestComplete?: boolean | null
  baaHipaatizerComplete?: boolean | null
  displayOrder?: number | null
}

export type ListOrganizationMembersQueryData = {
  listOrganizationMembers?: {
    edges?: Array<{
      cursor?: string | null
      node?: ListOrganizationMembersMemberNode | null
    } | null> | null
    pageInfo?: {
      endCursor?: string | null
      hasNextPage?: boolean | null
      hasPreviousPage?: boolean | null
      startCursor?: string | null
    } | null
    totalCount?: number | null
  } | null
}

// Query to list all members for an organization
export const LIST_ORGANIZATION_MEMBERS = gql`
  query ListOrganizationMembers(
    $iOrganizationId: UUID!
    $after: Cursor
    $before: Cursor
    $first: Int
    $last: Int
  ) {
    listOrganizationMembers(
      iOrganizationId: $iOrganizationId
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        node {
          firstName
          joinedAt
          lastName
          organizationId
          displayRole
          isPublic
          photoUrl
          role
          userId
          providerId
          published
          profilePendingPublication
          providerProfilePublished
          baaZestComplete
          baaHipaatizerComplete
          displayOrder
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

export default LIST_ORGANIZATION_MEMBERS
